import React, { useState, useEffect, useContext } from 'react';
import CloudSyncRoundedIcon from '@mui/icons-material/CloudSyncRounded';
import { getToken } from '../../../api/Account';
import { DataContext } from '../../../context/DataContext';
import { getBlobSizeAsync } from '../../../api/Dashboard';
import { simpleMessage } from '../../../helpers/Helpers';
import KpiCard from '../../../components/ui/KpiCard';

const BlobSize = () => {
	const [size, setSize] = useState(0);
	const token = getToken();

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getBlobSizeAsync(token);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}

			setIsLoading(false);
			setSize(result.data.result);
		})();
	}, []);

	return (
		<KpiCard
			icon={<CloudSyncRoundedIcon sx={{ fontSize: 20 }} />}
			iconBg="action.hover"
			iconColor="text.secondary"
			value={size}
			label="Almacenamiento"
		/>
	);
};

export default BlobSize;
